import { ArrowRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Reveal } from './Reveal';

export function Callout({ title = 'Ready to talk through your project?', text = 'Share the property location and what you want repaired, replaced, or newly installed.' }) {
  return (
    <Reveal as="section" className="callout section-shell" variant="line">
      <div>
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
      <Link className="button button--primary" to="/contact">Request an Estimate <ArrowRight aria-hidden="true" size={18} weight="bold" /></Link>
    </Reveal>
  );
}
